module.exports = __webpack_public_path__ + "media/assets/icons/teenyicons_arrow-up-outline-b2c3d985937eb40753c3ade9e50f5d16.svg";